import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import classNames from 'classnames';
import { Enum } from '../../../library';
import { shallowCompareKeys } from './overflow-helpers';
import { ResizeSensor } from '../../resize-sensor';
export var OverflowDirection = function (OverflowDirection) {
  OverflowDirection[OverflowDirection["NONE"] = 0] = "NONE";
  OverflowDirection[OverflowDirection["GROW"] = 1] = "GROW";
  OverflowDirection[OverflowDirection["SHRINK"] = 2] = "SHRINK";
  return OverflowDirection;
}({});
var overflowListClasses = {
  MAIN: 'overflow-list',
  SPACER: 'overflow-list__spacer'
};
export var Boundary = Enum({
  START: 'start',
  END: 'end'
});
export var OverflowList = function (_React$Component) {
  _inherits(OverflowList, _React$Component);
  var _super = _createSuper(OverflowList);
  function OverflowList() {
    var _this;
    _classCallCheck(this, OverflowList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      direction: OverflowDirection.NONE,
      lastOverflowCount: 0,
      overflow: [],
      visible: _this.props.items
    });
    _defineProperty(_assertThisInitialized(_this), "previousWidths", new Map());
    _defineProperty(_assertThisInitialized(_this), "spacer", null);
    _defineProperty(_assertThisInitialized(_this), "resize", function (entries) {
      var growing = entries.some(function (entry) {
        var previousWidth = _this.previousWidths.get(entry.target) || 0;
        return entry.contentRect.width > previousWidth;
      });
      _this.repartition(growing);
      entries.forEach(function (entry) {
        return _this.previousWidths.set(entry.target, entry.contentRect.width);
      });
    });
    return _this;
  }
  _createClass(OverflowList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.repartition(false);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_nextProps, nextState) {
      return !(this.state !== nextState && shallowCompareKeys(this.state, nextState));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.observeParents !== this.props.observeParents) {
        console.warn('Observe Parents Changed');
      }
      if (prevProps.collapseFrom !== this.props.collapseFrom || prevProps.items !== this.props.items || prevProps.minVisibleItems !== this.props.minVisibleItems || prevProps.overflowRenderer !== this.props.overflowRenderer || prevProps.visibleItemRenderer !== this.props.visibleItemRenderer) {
        this.setState({
          direction: OverflowDirection.GROW,
          lastOverflowCount: 0,
          overflow: [],
          visible: this.props.items
        });
      }
      if (!shallowCompareKeys(prevState, this.state)) {
        this.repartition(false);
      }
      var _this$state = this.state,
        direction = _this$state.direction,
        overflow = _this$state.overflow,
        lastOverflowCount = _this$state.lastOverflowCount;
      if (direction === OverflowDirection.NONE && direction !== prevState.direction && overflow.length !== lastOverflowCount) {
        var _this$props$onOverflo, _this$props;
        (_this$props$onOverflo = (_this$props = this.props).onOverflow) === null || _this$props$onOverflo === void 0 || _this$props$onOverflo.call(_this$props, overflow);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        className = _this$props2.className,
        collapseFrom = _this$props2.collapseFrom,
        observeParents = _this$props2.observeParents,
        style = _this$props2.style,
        _this$props2$tagName = _this$props2.tagName,
        tagName = _this$props2$tagName === void 0 ? "div" : _this$props2$tagName,
        visibleItemRenderer = _this$props2.visibleItemRenderer;
      var overflow = this.maybeRenderOverflow();
      var list = React.createElement(tagName, {
        className: classNames(overflowListClasses.MAIN, className),
        style: style
      }, collapseFrom === Boundary.START ? overflow : null, this.state.visible.map(visibleItemRenderer), collapseFrom === Boundary.END ? overflow : null, React.createElement("div", {
        className: overflowListClasses.SPACER,
        ref: function ref(_ref) {
          return _this2.spacer = _ref;
        }
      }));
      return React.createElement(ResizeSensor, {
        onResize: this.resize,
        observeParents: observeParents
      }, list);
    }
  }, {
    key: "maybeRenderOverflow",
    value: function maybeRenderOverflow() {
      var overflow = this.state.overflow;
      if (overflow.length === 0) {
        return null;
      }
      return this.props.overflowRenderer(overflow);
    }
  }, {
    key: "repartition",
    value: function repartition(growing) {
      var _this3 = this;
      if (this.spacer == null) {
        return;
      }
      if (growing) {
        this.setState(function (state) {
          return {
            direction: OverflowDirection.GROW,
            lastOverflowCount: state.direction === OverflowDirection.NONE ? state.overflow.length : state.lastOverflowCount,
            overflow: [],
            visible: _this3.props.items
          };
        });
      } else if (this.spacer.getBoundingClientRect().width < 0.9) {
        this.setState(function (state) {
          if (state.visible.length <= _this3.props.minVisibleItems) {
            return null;
          }
          var collapseFromStart = _this3.props.collapseFrom === Boundary.START;
          var visible = state.visible.slice();
          var next = collapseFromStart ? visible.shift() : visible.pop();
          if (next === undefined) {
            return null;
          }
          var overflow = collapseFromStart ? [].concat(_toConsumableArray(state.overflow), [next]) : [next].concat(_toConsumableArray(state.overflow));
          return {
            direction: state.direction === OverflowDirection.NONE ? OverflowDirection.SHRINK : state.direction,
            overflow: overflow,
            visible: visible
          };
        });
      } else {
        this.setState({
          direction: OverflowDirection.NONE
        });
      }
    }
  }], [{
    key: "ofType",
    value: function ofType() {
      return OverflowList;
    }
  }]);
  return OverflowList;
}(React.Component);
_defineProperty(OverflowList, "displayName", "OverflowList");
_defineProperty(OverflowList, "defaultProps", {
  collapseFrom: Boundary.END,
  minVisibleItems: 0
});